// =============================================
// SERVICIO DE CONCILIACIÓN BANCARIA
// Maneja las peticiones al API de conciliación
// =============================================

import api from './api';

const bankReconciliationService = {
  // ============================================
  // CUENTAS BANCARIAS DEL CONDOMINIO (FI)
  // ============================================

  getAllFIAccounts: async () => {
    const response = await api.get('/FI-bank-accounts');
    return response.data;
  },

  getActiveFIAccounts: async () => {
    const response = await api.get('/FI-bank-accounts?is_active=true');
    return response.data;
  },

  createFIAccount: async (accountData) => {
    const response = await api.post('/FI-bank-accounts', accountData);
    return response.data;
  },

  updateFIAccount: async (id, accountData) => {
    const response = await api.put(`/FI-bank-accounts/${id}`, accountData);
    return response.data;
  },

  deleteFIAccount: async (id) => {
    const response = await api.delete(`/FI-bank-accounts/${id}`);
    return response.data;
  },

  // ============================================
  // CUENTAS BANCARIAS DE PROPIETARIOS
  // ============================================

  getAllOwnerAccounts: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/owner-bank-accounts?${params}`);
    return response.data;
  },

  createOwnerAccount: async (accountData) => {
    const response = await api.post('/owner-bank-accounts', accountData);
    return response.data;
  },

  updateOwnerAccount: async (id, accountData) => {
    const response = await api.put(`/owner-bank-accounts/${id}`, accountData);
    return response.data;
  },

  deleteOwnerAccount: async (id) => {
    const response = await api.delete(`/owner-bank-accounts/${id}`);
    return response.data;
  },

  // ============================================
  // IMPORTACIÓN Y TRANSACCIONES
  // ============================================

  previewImport: async (FIAccountId, file) => {
    const formData = new FormData();
    formData.append('FI_account_id', FIAccountId);
    formData.append('file', file);

    const response = await api.post('/bank-reconciliation/preview-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  confirmImport: async (FIAccountId, transactions) => {
    const response = await api.post('/bank-reconciliation/confirm-import', {
      FI_account_id: FIAccountId,
      transactions: transactions
    });
    return response.data;
  },

  getAllTransactions: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/bank-reconciliation/transactions?${params}`);
    return response.data;
  },

  getTransactionApplications: async (transactionId) => {
    const response = await api.get(`/bank-reconciliation/transactions/${transactionId}/applications`);
    return response.data;
  },

  reprocessTransaction: async (transactionId) => {
    const response = await api.post(`/bank-reconciliation/transactions/${transactionId}/reprocess`);
    return response.data;
  },

  getTransactionSuggestions: async (transactionId) => {
    const response = await api.get(`/bank-reconciliation/transactions/${transactionId}/suggestions`);
    return response.data;
  },

  applyPayment: async (transactionId, paymentData) => {
    const response = await api.post(`/bank-reconciliation/transactions/${transactionId}/apply-payment`, paymentData);
    return response.data;
  },

  // ============================================
  // GASTOS PRE-REGISTRADOS
  // ============================================

  getExpenseDrafts: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/bank-reconciliation/expense-drafts?${params}`);
    return response.data;
  },

  completeExpenseDraft: async (draftId, data) => {
    const response = await api.post(`/bank-reconciliation/expense-drafts/${draftId}/complete`, data);
    return response.data;
  },

  rejectExpenseDraft: async (draftId) => {
    const response = await api.post(`/bank-reconciliation/expense-drafts/${draftId}/reject`);
    return response.data;
  },

  // ============================================
  // PALABRAS CLAVE
  // ============================================

  getAllKeywords: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/category-keywords?${params}`);
    return response.data;
  },

  getKeywordsByCategory: async (categoryId) => {
    const response = await api.get(`/category-keywords/by-category/${categoryId}`);
    return response.data;
  },

  createKeyword: async (keywordData) => {
    const response = await api.post('/category-keywords', keywordData);
    return response.data;
  },

  createBulkKeywords: async (categoryId, keywords) => {
    const response = await api.post('/category-keywords/bulk', {
      category_id: categoryId,
      keywords: keywords
    });
    return response.data;
  },

  updateKeyword: async (id, keywordData) => {
    const response = await api.put(`/category-keywords/${id}`, keywordData);
    return response.data;
  },

  deleteKeyword: async (id) => {
    const response = await api.delete(`/category-keywords/${id}`);
    return response.data;
  },
};

export default bankReconciliationService;
